import { forwardRef, memo, useState } from 'react';
import { HideIcon, ViewIcon } from '@page/icons';

import { IconButton } from '../../designSystem/IconButton';
import { Input, InputProps } from '../../designSystem/Input';
import { cn } from '../../lib/styles';

type PasswordInputProps = Omit<InputProps, 'type'>;

const PasswordInputBase = (
  { rightIcon, rightIconClassName, ...rest }: PasswordInputProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Input
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      rightIcon={
        rightIcon ?? (
          <IconButton
            size="sm"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <HideIcon className="min-w-5 size-5" /> : <ViewIcon className="min-w-5 size-5" />}
          </IconButton>
        )
      }
      rightIconClassName={cn('right-2', rightIconClassName)}
      {...rest}
    />
  );
};

export const PasswordInput = memo(forwardRef(PasswordInputBase));
